import { ISpinnerProps } from "@fluentui/react/lib/Spinner";

export const defaultProps: ISpinnerProps = {
    className: ''
};